import type { HelpFile } from '../../types/help'
import { SapSfEcInboundConfigCardTestIds } from '../../../testids/SapSfEcInboundConfigCardTestIds'

export const sapSfEcInboundConfigCardHelp: HelpFile = {
  docPage: '/docs/connectors/sap-sf-ec-connector',
  texts: {
    [SapSfEcInboundConfigCardTestIds.sapSfEcConfigSection]:
      'OData V2 inbound connector for SAP SuccessFactors Employee Central. Authenticates via OAuth2 client credentials or OAuth2 SAML 2.0 bearer assertion (RFC 7522) — the SAML path is required for IAS-fronted tenants.',
    [SapSfEcInboundConfigCardTestIds.cardTitleSapSfEcConfig]: null,
    [SapSfEcInboundConfigCardTestIds.btnEditSapSfEcConfig]: null,
  },
}
